import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
import { nl2br } from 'react-js-nl2br';

import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';
//import { Helmet } from 'react-helmet';

import * as Hosts from '../../../Hosts';
import { reqGET, repo_img_link, content_language, set_language, translate } from '../../../Utils';

import Loader from '../../../loader';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Preview from '../Preview/Preview';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

import AssecImage from "../ASSEC_Image/Image"

import { language } from '../WEBContent/Language';

export default function Animation(props) {
    // const { pathname } = useLocation();

    const [isloading, setLoading] = useState(true);

    const data_interface = {
        id: '',
        info: {},
        content: {}
    }
    const [content, set_content] = useState(data_interface);
    const [dados_config, set_dados_config] = useState({});

    const [lang, set_lang] = useState('pt');
    const [/*lang_id*/, set_lang_id] = useState('1');

    const [link, set_link] = useState('')

    useEffect(() => {
        /* console.log('aaaa') */
        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })
        }

        if(props.info !== undefined && props.info !== null && props.info !== '') {
            set_dados_config(props.info.state.dados_config)
        }

        try {
			let id = props.info.state.id;
			let slug = props.info.state.slug;
			let preview_id = props.info.state.preview;

            if(id !== '') {
        
                let getPreviewInfoId = async () => {
                    await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${preview_id}`)
                        .then(res => { 
                            if(res.data.length > 0) {
                                res.data[0].info['preview'] = true

                                if(res.data[0].content[0].contacts !== undefined && res.data[0].content[0].contacts['website'] !== undefined && res.data[0].content[0].contacts['website'] !== '') {
                                    const { hostname } = new URL(res.data[0].content[0].contacts['website'].includes('http') ? res.data[0].content[0].contacts['website'] : 'http://' + res.data[0].content[0].contacts['website'])
                                    set_link(hostname)
                                }

                                var hoje = new Date();
                                let status = 0
                                if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                                    var date_p = new Date(res.data[0].info.date.published);
        
                                    status = 1
                                    if(hoje >= date_p) 
                                        status = 2
                                }
       
                                if(res.data[0].info.preview === true) {
                                    //res.data[0].content = {text: 'preview'}
                                    console.log('Normal Preview')
        
                                    set_content(res.data[0])
                                    setLoading(false)   
                                }
                                else if(status !== 2) {
                                    res.data[0].content = {text: 'rascunho ou agendado'}
        
                                    set_content(res.data[0])
                                    setLoading(false)    
                                }
                                else {
                                    set_content(res.data[0]) 

                                    setLoading(false) 
                                }
                            }
                        })
                        .catch(erro => console.log('ERROR', erro))
                }

                let getInfoId = async () => {
                    await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${id}`)
                        .then(res => { 
                            if(res.data.length > 0) {
        
                                if(res.data[0].content[0].contacts !== undefined && res.data[0].content[0].contacts['website'] !== undefined && res.data[0].content[0].contacts['website'] !== '') {
                                    const { hostname } = new URL(res.data[0].content[0].contacts['website'].includes('http') ? res.data[0].content[0].contacts['website'] : 'http://' + res.data[0].content[0].contacts['website'])
                                    set_link(hostname)
                                }
        
                                var hoje = new Date();
                                let status = 0
                                if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                                    var date_p = new Date(res.data[0].info.date.published);
        
                                    status = 1
                                    if(hoje >= date_p) 
                                        status = 2
                                }
        
                                if(status !== 2) {
                                    res.data[0].content = {text: 'rascunho ou agendado'}
        
                                    set_content(res.data[0])
                                    setLoading(false)    
                                }
                                else {
                                    set_content(res.data[0]) 
            
                                    setLoading(false) 
                                }
                            }
                        })
                        .catch(erro => console.log('ERROR', erro))
                }
            
                let getInfoSlug = async () => {
                    reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/${slug}`)
                        .then(res => { 
                            if(res.data.length > 0) {
        
                                if(res.data[0].content[0].contacts !== undefined && res.data[0].content[0].contacts['website'] !== undefined && res.data[0].content[0].contacts['website'] !== '') {
                                    const { hostname } = new URL(res.data[0].content[0].contacts['website'].includes('http') ? res.data[0].content[0].contacts['website'] : 'http://' + res.data[0].content[0].contacts['website'])
                                    set_link(hostname)
                                }
        
                                var hoje = new Date();
                                let status = 0
                                if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                                    var date_p = new Date(res.data[0].info.date.published);
        
                                    status = 1
                                    if(hoje >= date_p) 
                                        status = 2
                                }
        
                                if(status !== 2)  {
                                    res.data[0].content = [{text: 'rascunho ou agendado'}]
        
                                    set_content(res.data[0])
                                    setLoading(false)
                                }
                                else {        
                                    set_content(res.data[0]) 
        
                                    setLoading(false) 
                                }
                            }
                        })
                        .catch(erro => console.log('ERROR', erro))
                }
        
                if(preview_id !== undefined && preview_id !== 'undefined' && preview_id !== '') {
                    getPreviewInfoId()
                }
                else if(id !== undefined && id !== 'undefined' && id !== '') {
                    getInfoId()
                }
                else if(slug !== undefined && slug !== 'undefined' && slug !== '')  {
                    getInfoSlug()
                }
            }
            else {
                console.log('=== ""')
            }

            return

        } catch {
            console.log('nada')

			return
		}
        
    }, [props.info, props.info.state.id, props.info.state.preview, props.info.state.slug]);

    return (isloading ?

		<Loader />
		
		:

        <>
            {
            content.info['preview'] === true ? 
                <Preview />
            : 
                null
            }
            <Navbar dados_config={dados_config} />
            <Breadcrumb />
            <main className="article">

                <div className="container-fluid bg-light py-5">
                    <div className="row">
                        <div className='container'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h3 className="titulo-primario">
                                        <span>{content.content[0].title}</span>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                content.content.map((el, k) => {  
                    return (
                        <section key={k} className="content-body">
                            <div className="container my-5">
                                <div className="row">
                                    <div className="col-12 text-right">
                                        <a className="btn btn-text" href={'./animation/all'} >
                                            <i className="bi bi-chevron-left pr-1"></i>{language[lang].back}
                                        </a>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 div-content mt-5">
                                        <div className="row">
                                            <div className='col-12 col-md-8 mb-5'>
                                                <div className='row'>
                                                    <div className='col-12 col-sm-4 mb-3'>
                                                        <div className="card bg-rotas rounded-lg text-white w-100 border-0">
                                                            <div className="card-header border-white text-center">
                                                                {new Date(el.date.begin).toLocaleDateString([], { year: 'numeric' })}
                                                                {
                                                                  (new Date(el.date.begin).toLocaleDateString([], { year: 'numeric' })) !== (new Date(el.date.end).toLocaleDateString([], { year: 'numeric' })) ?
                                                                    <>
                                                                        &nbsp;&#45;&nbsp;{new Date(el.date.end).toLocaleDateString([], { year: 'numeric' })}
                                                                    </>
                                                                  :
                                                                    null
                                                                }
                                                            </div>
                                                            <div className="card-body">
                                                                <h5>
                                                                    {new Date(el.date.begin).toLocaleDateString([], { month: 'long', day: 'numeric' })}
                                                                    {
                                                                    el.date.end !== '' && el.date.end !== el.date.begin ?
                                                                    <>
                                                                        <br />
                                                                        <span className='mr-1 mt-2'>{language[lang].date_to}</span>
                                                                        {new Date(el.date.end).toLocaleDateString([], { month: 'long', day: 'numeric' })}
                                                                    </>
                                                                    :
                                                                        null
                                                                    }
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-12 col-sm-8'>

                                                        <div className="card bg-animacao rounded-lg text-white w-100 border-0">
                                                            <div className="card-header border-white text-center">
                                                                {el.date.begin_time.replace(':', 'h')} 
                                                                {
                                                                    el.date.end_time !== '' && el.date.end_time !== el.date.begin_time ?
                                                                    <>
                                                                        &nbsp;&#45;&nbsp;
                                                                        {el.date.end_time.replace(':', 'h')}
                                                                    </>
                                                                    :
                                                                        null
                                                                    }
                                                            </div>
                                                            <div className="card-body">
                                                                <h5>
                                                                    {nl2br(el.ponto_encontro)}
                                                                </h5>

                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className='col-12 mt-5'>
                                                        <div className={"div-text"}>
                                                            <div className="d-flex flex-nowrap flex-column">
                                                                <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}>
                                                                    <i className="bi bi-globe mr-2"></i> 
                                                                    <a href={el.contacts.website.includes('http') ? el.contacts.website : 'http://' + el.contacts.website} alt="" target="_blank" rel="noreferrer">
                                                                        {
                                                                        link !== undefined ? link : null
                                                                        //el.contacts.website.includes(el.contacts.website_type) ? el.contacts.website : el.contacts.website_type + el.contacts.website
                                                                        }
                                                                    </a>
                                                                </span>
                                                                {
                                                                    el.contacts.email !== '' ?
                                                                        <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}><i className="bi bi-envelope mr-2"></i>

                                                                        <a href={'mailto: '+ el.contacts.email} alt="" target="_blank" rel="noreferrer">{el.contacts.email}</a>


                                                                        </span>
                                                                    :
                                                                        null
                                                                    } 
                                                                {
                                                                    content.info.category !== '' ?
                                                                        <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}} className='d-none'><strong>{content.info.category}</strong></span>
                                                                    :
                                                                        null
                                                                    }
                                                                {
                                                                    el.contacts.tlf !== '' ?
                                                                        <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}><i className="bi bi-telephone mr-2"></i> <a href={"tel:" + el.contacts.tlf}>{el.contacts.tlf}</a></span>
                                                                    :
                                                                        null
                                                                    }
                                                                {
                                                                    el.contacts.tlm !== '' ?
                                                                        <span style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', lineHeight: '2'}}><i className="bi bi-phone mr-2"></i> <a href={"tel: " + el.contacts.tlm}>{el.contacts.tlm}</a> <br /></span>
                                                                    :
                                                                        null
                                                                    }
                                                            </div>
                                                                {
                                                                el.value !== '' ?
                                                                    <div className="mt-3">
                                                                        <h5 className="d-inline-block bg-rotas text-white p-3 mb-0">{translate(el.value, lang)}</h5>
                                                                    </div>
                                                                :
                                                                    null
                                                                }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-4 mb-5'>
                                                <div className={"div-image"}>
                                                    {
                                                        el['media']['image'][0] !== undefined ?
                                                            <a
                                                                href={el['media']['image'][0]['link']}
                                                                data-fancybox="gallery"
                                                                data-caption={el['media']['image'][0]['link'].includes(el['media']['image'][0]['name']) ? '' : el['media']['image'][0]['name']}
                                                            >
                                                                <AssecImage 
                                                                    linkImage={el['media']['image'][0]['link']}
                                                                    width="400"
                                                                    height="300"
                                                                    fit='crop'
                                                                    type='img'
                                                                    //sClass="img-fluid shadow-lg py-3 px-5" 
                                                                    sClass="img-fluid rounded shadow-sm" 
                                                                    alt={el['media']['image'][0]['name']}
                                                                />
                                                            </a>
                                                        :
                                                            <AssecImage 
                                                                linkImage={repo_img_link('nophoto.webp')}
                                                                width="400"
                                                                height="300"
                                                                fit='crop'
                                                                type='img'
                                                                sClass="img-fluid rounded shadow-sm" 
                                                                alt="no_photo"
                                                            />
                                                    }
                                                    {/*<img src={el['media']['image'][0] !== undefined ? el['media']['image'][0]['link'] : null} className="img-fluid" alt="" />*/}
                                                </div>
                                            </div>

                                            <div className='col-12'>

                                                <div className={"div-abstract mt-3 d-none"}>
                                                    <p>{ReactHtmlParser(el.abstract)}</p>
                                                </div>

                                                <div className="div-categories d-none w-100"><i className="bi bi-tag" />
                                                    {
                                                    content.info.tags.map((v, k) => {
                                                        return (
                                                            <span key={k} className="pill-tag">{v.text}</span>
                                                        )
                                                    })
                                                    }
                                                </div>

                                                {
                                                    el.text !== undefined && el.text.length > 0 ?
                                                        <div className={"div-text"}>
                                                            {ReactHtmlParser(translate(el.text, lang))}
                                                            {/*ReactHtmlParser(lang === 'pt' || el.language === undefined ? el.text : (el.language[lang_id] === undefined || el.language[lang_id] === null || el.language[lang_id].text === undefined || el.language[lang_id].text === '' ? el.text : el.language[lang_id].text))*/}
                                                        </div>
                                                    :
                                                    null
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    {
                                        el['media'] !== undefined && el['media']['doc'] !== undefined && el.media.doc.length > 0 ?
                                            <div className="col-12 div-content mt-5">
                                                <div className="row div-documents">
                                                    {
                                                    el.media.doc.map((el_doc, k_doc) => {
                                                        return (
                                                            <div key={k_doc} className="mb-2">
                                                                <img className="img-fluid" src={el_doc.link} alt="" />
                                                                <a className="btn btn-primary" href={el_doc.link} target="_blank" rel="noreferrer">{el_doc.name}</a>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        :
                                            <></>
                                        }
                                    {
                                        el['media'] !== undefined && el['media']['image'] !== undefined && el.media.image.length > 1 ?
                                            <div className="col-12 div-content mt-5">
                                                <div className="row no-gutters div-gallery">
                                                    {
                                                    el.media.image.map((el_img, k_img) => {
                                                        if(k_img > 0) {
                                                            return (
                                                                <div key={k_img} className="col-6 col-sm-3 col-lg-2">
                                                                    <a
                                                                        href={el_img.link}
                                                                        data-fancybox="gallery"
                                                                        data-caption={(el_img.link.includes(el_img.name) || el_img.name.includes('webp') || el_img.name.includes('jpg') || el_img.name.includes('png')) ? '' : el_img.name}
                                                                    >
                                                                        <AssecImage
                                                                            linkImage={el_img.link !== undefined ? el_img.link : repo_img_link('nophoto.png')}
                                                                            width="400"
                                                                            height="400"
                                                                            fit='crop'
                                                                            type='img'
                                                                            sClass='img-fluid'
                                                                            alt={el_img.name}
                                                                            title={(el_img.link.includes(el_img.name) || el_img.name.includes('webp') || el_img.name.includes('jpg') || el_img.name.includes('png')) ? '' : el_img.name}
                                                                        />
                                                                    </a>
                                                                </div>
                                                            )
                                                        }
                                                        else
                                                            return null
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        :
                                            <></>
                                    }
                                </div>
                            </div>
                        </section>
                    )
                })
                }
            </main>
            <Footer dados_config={dados_config} />
        </>
    )
}